// extracted by mini-css-extract-plugin
export default {"chart":"NewCustomer_chart__Dgoo8","legend":"NewCustomer_legend__fcvdX","indicator":"NewCustomer_indicator__lbIWG","color":"NewCustomer_color__WdmWc"};